module.exports = __webpack_public_path__ + "img/expers.b2fb6cd7.png";